
import { Options, prop, Vue } from "vue-class-component";
import {
  FILTER_MONTH_LEADERBOARD_KEYS,
  getMonthTabs,
  MONTH_NAMES
} from "../LeaderboardUtils";
import debounce from "lodash/debounce";
import CustomSelect from "@/app/ui/components/custom-dropdown/index.vue";
import { OptionsClass } from "@/domain/entities/MainApp";

class Props {
  month = prop<{ value: string; key: string } | null>({
    default: null
  });
}

@Options({
  emits: ["update:month"],
  components: {
    CustomSelect
  }
})
export default class FilterMonthLeaderBoard extends Vue.with(Props) {
  mounted() {
    if (this.monthsData) {
      this.monthsData.monthTabs;
      this.onSelectMonth(this.monthsData.monthTabs.currentMonth);
    }
  }

  selectedMonth: OptionsClass = new OptionsClass();
  isCustom = false;

  get monthsOptions() {
    return MONTH_NAMES;
  }

  get monthsData() {
    return getMonthTabs();
  }

  get filterMonthLeaderboardKeys() {
    return FILTER_MONTH_LEADERBOARD_KEYS;
  }

  onSelectMonth = debounce(async (monthValue: OptionsClass) => {
    if (
      monthValue.name === this.selectedMonth.name &&
      monthValue.code === this.selectedMonth.code
    ) {
      return;
    }

    const { currentYear, monthTabs } = this.monthsData;
    let monthResult = "";

    // if current month is January and user choose December,
    // then monthResult should be December of previous year.
    if (
      monthValue.code === "tab" &&
      monthTabs.currentMonth.name === "Januari" &&
      monthValue.name === "Desember"
    ) {
      monthResult = `${currentYear - 1}-${monthValue.value}`;
    } else {
      monthResult = `${currentYear}-${monthValue.value}`;
    }

    if (monthValue.code === "tab") {
      this.isCustom = false;
    }

    const newOptionClass = new OptionsClass({
      value: monthResult,
      name: monthValue.name,
      key: this.isCustom
        ? this.filterMonthLeaderboardKeys.CUSTOM
        : monthValue.key,
      code: monthValue.code
    });

    if (!monthValue.key) {
      if (monthValue.name === monthTabs.previousMonth.name) {
        newOptionClass.key = monthTabs.previousMonth.key;
      } else if (monthValue.name === monthTabs.currentMonth.name) {
        newOptionClass.key = monthTabs.currentMonth.key;
      }
    }

    this.selectedMonth = newOptionClass;
    this.$emit("update:month", newOptionClass);
  }, 250);

  setIsCustom() {
    if (!this.isCustom) {
      this.isCustom = !this.isCustom;
      this.selectedMonth = { name: "", value: "" };
      this.$emit(
        "update:month",
        new OptionsClass({
          key: this.filterMonthLeaderboardKeys.CUSTOM
        })
      );
    }
  }
}
